import { useQuery } from "react-query"
import { request } from "../../Axios/axios-util"
import { IApiRequestParams } from "../../Interfaces/IApiRequestParams"
import { IRequestParams } from "../../Interfaces/IRequestParams"
import { consolelog } from "../../helpers/consolelog"

function getRequestApi<ResultType>(
  params: IApiRequestParams
): Promise<ResultType> {
  let urlStub: string = `${params.service}`
  if (params.isPaginationRequired) {
    if (params.skip !== undefined) {
      urlStub += `&$skip=${params.skip}`
    }
    if (params.take > 0) {
      urlStub += `&$top=${params.take}`
    }
    if (params.filter !== "" && params.filter !== null && params.filter !== undefined) {
      urlStub += `&$filter=${params.filter}`
    }
  }
  if (params.responseType !== "" && params.responseType !== undefined) {
    if (params.filter !== "" && params.filter !== null) {
      urlStub += `?$filter=${params.filter}`
    }
    return request({ url: urlStub, responseType: 'blob' }).then((res) => res)
  }
  return request({ url: urlStub }).then((res) => res)
}

function searchRequestApi<ResultType>(params: IApiRequestParams): Promise<ResultType> {
  let urlStub: string = `${params.service}`

  if (params.filter !== "" && params.filter !== null && params.filter !== undefined) {
    urlStub += `?query=${params.filter}`
  }
  else {
    urlStub += `?query=""`
  }

  if (params.isPaginationRequired) {
    urlStub += "&count=true";

    if (params.skip !== undefined) {
      urlStub += `&skip=${params.skip}`
    }
    if (params.take > 0) {
      urlStub += `&take=${params.take}`
    }
  }

  return request({ url: urlStub }).then((res) => res)
}


export const useGetApi = (params: IRequestParams) => {
  if (params.method === null || params.method === undefined) {
    params.method = "get";
  }

  if (params.isPaginationRequired) {
    if (params.key === "" || params.key === undefined) {
      params.key = `key${params.service}-data-${params.skip}-${params.take}${params.filter}`
    }
  } else {
    params.key = `key${params.service}`
  }

  let result = useQuery<any, Error>([params.key], () => params.method == "get" ? getRequestApi(params) : searchRequestApi(params), {
    onSuccess: params.onSuccess,
    onError: params.onError,
    refetchOnWindowFocus: params.refetchOnWindowFocus,
    select: (response) => {
      return response
    },
    enabled: params.isEnabled,
  })
  //consolelog('Result:', JSON.stringify(result))
  return result
}

export function getRequestApiMasterData<ResultType>(params: IApiRequestParams): Promise<ResultType> {
  let urlStub: string = `${params.service}`
  if (params.filter !== "") {
    urlStub += `?$filter=${params.filter}`
  }
  return request({ url: urlStub }).then((res) => res)
}

export const getBooleanData = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    resolve(
      {
        "value": [
          {
            Label: "True",
            value: true,
          },
          {
            Label: "False",
            value: false,
          },
        ],

      });
  });
};